var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable parog-web/migrate-non-patch-forms */

import { action } from "@ember/object";
import { service } from "@ember/service";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import BioExamPrescribedJournalEvent from "core/models/bio-exam-prescribed-journal-event";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import ConsultationReportWrittenJournalEvent from "core/models/consultation-report-written-journal-event";
import DpCycleDeclaredJournalEvent from "core/models/dp-cycle-declared-journal-event";
import File from "core/models/file";
import FileUploadedJournalEvent from "core/models/file-uploaded-journal-event";
import MedicalEventJournalEvent from "core/models/medical-event-journal-event";
import MedicalImagingPrescribedJournalEvent from "core/models/medical-imaging-prescribed-journal-event";
import MedicationPrescribedJournalEvent from "core/models/medication-prescribed-journal-event";
import ParamedicalCarePrescribedJournalEvent from "core/models/paramedical-care-prescribed-journal-event";
import Patient from "core/models/patient";
import ParogService from "core/services/parog";
import emberSwal from "ui-kit/utils/ember-swal";
import { ForcBaseArgs } from "./base-component";
let CrudJournalEventBaseComponent = (_class = class CrudJournalEventBaseComponent extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "parog", _descriptor, this);
  }
  /**
   * Use
   * <WrForm @data={{this.typedChangeset}}>
   * instead of
   * <WrForm @data={{this.changeset}}>
   * to get full typing support in your form
   *
   * See https://github.com/CrowdStrike/ember-headless-form/issues/211
   */
  get typedChangeset() {
    return this.changeset;
  }
  get model() {
    if (this.isNewMode) {
      return this.store.createRecord(this.journalEventClassType, {
        occurredAt: new Date(),
        ...this.initialModel
      });
    }
    return this.retrievedJournalEvent;
  }
  get initialModel() {
    return {};
  }
  async beforeSave() {
    return;
  }
  async saveWithFiles(journalEventClassType = this.journalEventClassType) {
    if (!this.isDirty) {
      return;
    }
    this.changeset.set("patient", this.args.patient);
    await this.beforeSave();
    await this.changeset.validate();
    const journalEventPayload = this.changeset.execute().data.serialize().data;
    journalEventPayload["type"] = `${journalEventClassType}s`;
    this.changeset.rollback();
    const body = JSON.stringify({
      data: {
        "journal-event": {
          data: journalEventPayload
        },
        "file-attachments": this.changeset.get("files").map(file => file.fileAttachment.serialize()),
        "file-contents": this.changeset.get("files").map(file => file.fileContent.serialize())
      }
    });
    let journalEvent;
    const {
      response,
      content
    } = await this.requestManager.request({
      url: "/api/v1/journal_event_with_attachment",
      method: "POST",
      body: body
    });
    if (!response.ok) {
      emberSwal.fire({
        title: "Oups, échec de l'importation de votre document.",
        text: "Veuillez réessayer ou contacter le support Sêmeia si le problème persiste.",
        icon: "error"
      });
    } else {
      // Fetch saved record
      journalEvent = await this.store.findRecord(content.data.type.slice(0, -1), content.data.id, {
        include: "file-attachments"
      });
    }
    return journalEvent;
  }
  async save() {
    if (this.changeset.get("files")) {
      return await this.saveWithFiles();
    }
    if (!this.isDirty) {
      return;
    }

    /**
     * Set the patient before saving the changeset, if the record
     * is new.
     * As it is done in the `computePayload` method.
     */
    if (this.isNewMode) {
      this.changeset.set("patient", this.args.patient);
    }
    await this.changeset.execute();
    await this.beforeSave();
    await this.changeset.save();
    await this.draft.onDidSave();

    /**
     * Unlike Forc::Provdider, WrForm is not responsible of any logic after submitting the form
     * under Wiser, this logic now belongs to this save method
     */
    if (this.parog.wiser && this.args.afterCompleted) this.args.afterCompleted();
    super.popToast();
    return this.changeset.data;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "parog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "saveWithFiles", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveWithFiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _class);
export { CrudJournalEventBaseComponent as default };